import { Avatar, Box, Text, styled } from '@ltvco/refresh-lib/theme';

export const MobileNavItemButton = styled('button')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '32px !important',
  cursor: 'pointer',
  border: 0,
  background: 'transparent',
  padding: 0,
  width: '100%',
  textAlign: 'left',
});

export const CloseSidebarButton = styled('button')({
  border: 0,
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  lineHeight: 0,
});

export const SidebarNavText = styled(Text)<{ $marginTop: string }>(
  ({ theme, $marginTop }) => ({
    fontWeight: 'bold',
    textWrap: 'nowrap',
    cursor: 'pointer',
    marginTop: `${$marginTop} !important`,
    '&:hover': { color: theme.palette.primary.main },
  })
);

export const SidebarAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  fontSize: '12px',
  width: '24px',
  height: '24px',
  '&:hover': { backgroundColor: theme.palette.button.dark },
}));

export const MobileProfileBox = styled(Box)({
  padding: '8px',
  borderRadius: '4px',
  cursor: 'pointer',
});

export const ScrollableConversationBox = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${theme.palette.grey[500]} transparent`,
  '&::-webkit-scrollbar': {
    width: '6px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[500],
    borderRadius: '8px',
  },
}));

export const AccountBox = styled(Box)(({ theme }) => ({
  marginLeft: '-48px !important',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  cursor: 'pointer',
  '&:hover .account-icon, &:hover .account-text': {
    color: theme.palette.primary.main,
  },
}));

export const AccountNavText = styled(Text)({
  fontWeight: 'bold',
  textWrap: 'nowrap' as const,
});
